import { useQuery } from "@tanstack/react-query";
import { parameterResyncQueryKey } from "../lib/parameter-resync";

/** Subscribes to the cache-backed re-sync flag for an image. True while the
 * backend is re-reading auto parameter values from the rendered image. */
export function useParameterResyncPending(
  imageId: string | undefined,
): boolean {
  const { data } = useQuery({
    queryKey: parameterResyncQueryKey(imageId ?? ""),
    // Never fetched — the value is only ever written via setQueryData.
    queryFn: () => false,
    enabled: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
  // Ignore the shared empty-string key's data when there is no real ID.
  return Boolean(imageId) && data === true;
}
